import React from "react"

import { Table, Thead, Tbody, Tr, Th, Td } from "../el/table"

const RcProtocolTable = () => {
  return (
    <Table>
      <Thead>
        <tr>
          <Th className="border-r-4 border-slate-300">Cell Line Viability</Th>
          <Th className="border-r-4 border-slate-300 text-center" colSpan="2">
            99%-70%
          </Th>
          <Th className="border-r-4 border-slate-300 text-center" colSpan="2">
            69%-50%
          </Th>
          <Th className="border-r-4 border-slate-300 text-center" colSpan="2">
            49%-40%
          </Th>
          <Th className="text-center" colSpan="2">
            39%-0%
            <br />
            Spin for 7min @ 4000g*
          </Th>
        </tr>
        <tr>
          <Th className="border-r-4 border-slate-300">
            <b>Cell Type</b>
          </Th>
          <Th className="text-center">
            Volume
            <br />
            (L)
          </Th>
          <Th className="border-r-4 border-slate-300 text-center">
            Time
            <br />
            (min)
          </Th>
          <Th className="text-center ">
            Volume
            <br />
            (L)
          </Th>
          <Th className="border-r-4 border-slate-300 text-center">
            Time
            <br />
            (min)
          </Th>
          <Th className="text-center">
            Volume
            <br />
            (L)
          </Th>
          <Th className="border-r-4 border-slate-300 text-center">
            Time
            <br />
            (min)
          </Th>
          <Th className="text-center">
            Volume
            <br />
            (L)
          </Th>
          <Th className="text-center">
            Time
            <br />
            (min)
          </Th>
        </tr>
      </Thead>

      <Tbody>
        <Tr>
          <Td className="border-r-4 border-slate-300">
            <b>CHO Stable without Feed</b>
          </Td>
          <Td className="text-center">3.0</Td>
          <Td className="border-r-4 border-slate-300 text-center">18</Td>
          <Td className="text-center">2.5</Td>
          <Td className="border-r-4 border-slate-300 text-center">18</Td>
          <Td className="text-center">2.0</Td>
          <Td className="border-r-4 border-slate-300 text-center">20</Td>
          <Td className="text-center">3.5****</Td>
          <Td className="text-center">35****</Td>
        </Tr>

        <Tr>
          <Td className="border-r-4 border-slate-300">
            <b>CHO Stable, 1 to 2 Feeds</b>
          </Td>
          <Td className="text-center">2.0</Td>
          <Td className="border-r-4 border-slate-300 text-center">18</Td>
          <Td className="text-center">2.0</Td>
          <Td className="border-r-4 border-slate-300 text-center">18</Td>
          <Td className="text-center">1.5</Td>
          <Td className="border-r-4 border-slate-300 text-center">35</Td>
          <Td className="text-center"></Td>
          <Td className="text-center"></Td>
        </Tr>

        <Tr>
          <Td className="border-r-4 border-slate-300">
            <b>CHO Stable, 2+ Feeds</b>
          </Td>
          <Td className="text-center" colspan="8">
            Spin for 7 min @ 4000g; ≤3L volume ****
          </Td>
        </Tr>

        <Tr>
          <Td className="border-r-4 border-slate-300">
            <b>HEK293 (FreeStyle&trade; & Expi293)</b>
          </Td>
          <Td className="text-center">3.0</Td>
          <Td className="border-r-4 border-slate-300 text-center">18</Td>
          <Td className="text-center">3.0</Td>
          <Td className="border-r-4 border-slate-300 text-center">23</Td>
          <Td className="text-center">3.0</Td>
          <Td className="border-r-4 border-slate-300 text-center">25</Td>
          <Td className="text-center">3.5****</Td>
          <Td className="text-center">35****</Td>
        </Tr>

        <Tr>
          <Td className="border-r-4 border-slate-300">
            <b>CHO Transient</b>
          </Td>
          <Td className="text-center">3.0</Td>
          <Td className="border-r-4 border-slate-300 text-center">18</Td>
          <Td className="text-center">2.5</Td>
          <Td className="border-r-4 border-slate-300 text-center">18</Td>
          <Td className="text-center">1.5</Td>
          <Td className="border-r-4 border-slate-300 text-center">35</Td>
          <Td className="text-center"></Td>
          <Td className="text-center"></Td>
        </Tr>

        <Tr>
          <Td className="border-r-4 border-slate-300">
            <b>ExpiCHO</b>
          </Td>
          <Td className="text-center">3.0</Td>
          <Td className="border-r-4 border-slate-300 text-center">18</Td>
          <Td className="text-center">2.5</Td>
          <Td className="border-r-4 border-slate-300 text-center">18</Td>
          <Td className="text-center">1.0</Td>
          <Td className="border-r-4 border-slate-300 text-center">18</Td>
          <Td className="text-center"></Td>
          <Td className="text-center"></Td>
        </Tr>
      </Tbody>
    </Table>
  )
}

export default RcProtocolTable
